// 📁 File: src/Pages/IncomingCallPage.js
import { useEffect, useState } from "react";
import { Box, Button, Text, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAudioCall } from "../hooks/useAudioCall";
import socket from "../socket";

const IncomingCallPage = () => {
  const [callerInfo, setCallerInfo] = useState(null);
  const [signal, setSignal] = useState(null);
  const [myId, setMyId] = useState(null);
  const navigate = useNavigate();

  const { answerCall } = useAudioCall(myId, callerInfo?.id);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const incomingCall = JSON.parse(localStorage.getItem("incomingCall"));

    if (incomingCall) {
      setCallerInfo(incomingCall.callerInfo);
      setSignal(incomingCall.signal);
    }

    if (userInfo?._id) {
      setMyId(userInfo._id);
      socket.emit("setup", userInfo); // assuming your backend expects this
    }

    // Listen for live call notifications
    const handleIncoming = ({ from, signal, callerInfo }) => {
      setSignal(signal);
      setCallerInfo(callerInfo);
      localStorage.setItem(
        "incomingCall",
        JSON.stringify({ signal, callerInfo })
      );
    };

    socket.on("call:incoming", handleIncoming);

    return () => {
      socket.off("call:incoming", handleIncoming);
    };
  }, []);

  const handleAnswer = () => {
    if (!signal || !myId || !callerInfo?.id) {
      console.warn("Cannot answer call – missing data");
      return;
    }

    answerCall(signal);
    localStorage.removeItem("incomingCall");
    // navigate("/chatpage");
  };

  if (!callerInfo) {
    return (
      <Box textAlign="center" mt={20}>
        <Text fontSize="xl">📞 Waiting for incoming call...</Text>
      </Box>
    );
  }

  return (
    <Box textAlign="center" mt={10}>
      <Image
        src={callerInfo.avatar}
        borderRadius="full"
        boxSize="150px"
        mx="auto"
        alt={callerInfo.name}
      />
      <Text fontSize="2xl" mt={4}>
        Incoming call from {callerInfo.name}
      </Text>
      <Text color="gray.600" mt={2}>
        Email: {callerInfo.email}
      </Text>
      <Text color="gray.500">User ID: {callerInfo.id}</Text>
      <Button colorScheme="green" mt={6} onClick={handleAnswer}>
        Answer
      </Button>
    </Box>
  );
};

export default IncomingCallPage;
